<mat-form-field class="mat-form-field-sm"
                subscriptSizing="dynamic"
                appearance="outline">
  <mat-select [ngModel]="currentLoan?.id"
              name="Loan"
              (selectionChange)="onChangeLoan($event.value)">
    <ng-container *ngFor="let loan of loans">
      <mat-option [value]="loan?.id">
        {{ loan.description || loan?.loanNumber }}
      </mat-option>
      <mat-divider></mat-divider>
    </ng-container>
  </mat-select>
  <mat-hint> {{ currentLoan?.entityDBA || currentLoan?.entityName}}</mat-hint>
</mat-form-field>
